<script setup lang="ts">
import { computed } from 'vue';
import BaseChip from '@/js/account/components/base/BaseChip.vue';
import BaseTitle from '@/js/account/components/base/BaseTitle.vue';
import ProfileDashboardAdmin from '@/js/account/components/dashboard/ProfileDashboardAdmin.vue';
import ProfileDashboardCustomer from '@/js/account/components/dashboard/ProfileDashboardCustomer.vue';
import ProfileHeader from '@/js/account/components/profile/ProfileHeader.vue';
import { useAuth } from '@/js/account/entities/session';
import { classNames } from '@/js/lib/bem';

const cn = classNames('profile-dashboard-page');

const { user, isAdmin } = useAuth();

const displayName = computed(() => {
  const name = user.value?.name?.trim();

  if (name) {
    return name.split(/\s+/)[0];
  }

  return user.value?.email?.split('@')[0] ?? 'there';
});
</script>

<template>
  <div :class="cn()">
    <ProfileHeader>
      <template #left>
        <BaseTitle size="md">
          Welcome, {{ displayName }}
        </BaseTitle>
      </template>
      <template #right>
        <BaseChip v-if="isAdmin && user?.email" theme="secondary" size="md">
          {{ user.email }}
        </BaseChip>
      </template>
    </ProfileHeader>

    <div :class="cn('content')">
      <!-- Distinct keys keep this v-if/v-else off Vue's block fast-path: without
        them the production compiler collects the inactive branch's (never
        mounted) component vnode into dynamicChildren, and unmounting the tree
        then crashed on it (`Cannot destructure 'bum' of null`), wedging routing. -->
      <ProfileDashboardAdmin v-if="isAdmin" key="dashboard-admin" />
      <ProfileDashboardCustomer v-else key="dashboard-customer" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.profile-dashboard-page {
  font-family: var(--font-family-sans);
  font-size: 24px;
  color: var(--color-text-primary);

  &__content {
    padding: 32px;
  }

  @media (max-width: 768px) {
    &__content {
      padding: 16px;
    }
  }
}
</style>
